import React from 'react'
import { Container, Card } from 'react-bootstrap'
import { SBText, PText } from 'application/components/styledComponents/text'
import styled from '@emotion/styled'

import RioTintoFormattedData from './rioTintoFormattedData'
import nswHNFormattedData from './nswHNFormattedData'
import SagByoFormattedData from './sagbyoFormattedData'
import { ITheme } from 'application/utils/type'
import {
  IDatablock,
  IStaticDataItem,
} from './proposalInterfaces/cardStaticDataTypes'
import { ICardChecklistItemProps } from './proposalInterfaces/cardCheckListItemProps'

interface IInputProps {
  isRioTinto: boolean
  isNSWHN: boolean
  isSAGBYO: boolean
  proposalAccepted: boolean
  pdf: boolean
  theme: ITheme
}

interface IStyledElementProps {
  theme: ITheme
}

export const ChecklistPdfSection = (props: IInputProps) => {
  const fnGetChecklistData = () => {
    if (props && props.isRioTinto) {
      return RioTintoFormattedData(props.theme)
    } else if (props && props.isNSWHN) {
      return nswHNFormattedData(props.theme)
    } else if(props && props.isSAGBYO) {
      return SagByoFormattedData(props.theme)
    }
    else {
      return null
    }
  }

  const checklistData: IStaticDataItem[] | null = fnGetChecklistData()
  const data =
    checklistData &&
    checklistData.find((c) => c.title === 'Your Salary Package Election')

  return (
    <>
      {props.proposalAccepted && (
        <div>blu
          <Container className="section mt-4">
            {checklistData &&
              checklistData.map((c) => {
                if (!c.hideInPdf)
                  return (
                    <Card
                      className={
                        props.pdf ? 'mb-13rem pdf-card-container' : 'mb-13rem'
                      }
                    >
                      <Card.Header
                        className={
                          props.pdf
                            ? 'border-bottom-0 pdf-card'
                            : 'border-bottom-0'
                        }
                      >
                        <div className="text-header">
                          {c.cardHeadingNumber + 1}. {c.title}
                        </div>
                      </Card.Header>

                      <Card.Body>
                        {c.prefix && !props.pdf && (
                          <Card.Body>{c.prefix}</Card.Body>
                        )}
                        {c.prefixPdf && (
                          <div className="mb-3">{c.prefixPdf}</div>
                        )}
                        <PText className="mb-3" theme={props.theme}>
                          {c.pdfText}
                        </PText>

                        {c.datablocks.map((db: IDatablock) => {
                          return (
                            <div>
                              <SBText theme={props.theme}>{db.heading}</SBText>
                              {db.checklistItems.map(
                                (cli: ICardChecklistItemProps) => {
                                  return (
                                    <ChecklistContentSection
                                      theme={props.theme}
                                    >
                                      <div>
                                        {' '}
                                        <img
                                          src="/images/select-icon.svg"
                                          alt=""
                                        />
                                      </div>
                                      {db.showIds && <div>{cli.id}</div>}
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: cli.text,
                                        }}
                                      />
                                    </ChecklistContentSection>
                                  )
                                }
                              )}
                              {c.suffix}
                            </div>
                          )
                        })}
                      </Card.Body>
                    </Card>
                  )
              })}
          </Container>
        </div>
      )}
      {!props.proposalAccepted &&
        props.isRioTinto && ( // This has to be displayed if proposal is not in accepted state for RioTinto only
          <div>
            <Container className="section mt-4">
              <Card
                className={
                  props.pdf ? 'mb-13rem pdf-card-container' : 'mb-13rem'
                }
              >
                <Card.Header
                  className={
                    props.pdf ? 'border-bottom-0 pdf-card' : 'border-bottom-0'
                  }
                >
                  <div className="text-header">6. {data && data.title}</div>
                </Card.Header>

                <Card.Body>
                  {data && data.prefix && <div>{data.prefix}</div>}
                  {data && data.prefixPdf && <div>{data.prefixPdf}</div>}
                </Card.Body>
              </Card>
            </Container>
          </div>
        )}
    </>
  )
}

const ChecklistContentSection = styled('div')<IStyledElementProps>`
  label: ChecklistContentSection;
  display: flex;
  justify-content: space-between;
  margin: 18px 0;
  div:nth-child(2) {
    width: 20%;
    text-align: center;
    padding: 0 12px;
  }

  div:last-child {
    width: 185%;
    text-align: left;
    a {
      color: ${(props) => props.theme.colors.linkColor};
      font-weight: 700;
      text-decoration: underline;
    }
  }
`

const ChecklistContentBlock = styled('div')<IStyledElementProps>`
  label: ChecklistContentBlock;
  display: flex;
  justify-content: left;
  margin: 18px 0;
  div:first-child {
    width: 10%;
    text-align: left;
  }
  div:nth-child(2) {
    width: 185%;
    text-align: left;
  }
`

const ChecklistShadedBlock = styled('div')<IStyledElementProps>`
  label: ChecklistShadedBlock;
  background: ${(props) => props.theme.backgrounds.backGround3};
  padding: 9px;
  span {
    font-weight: 700;
  }
`
